module.exports = __webpack_public_path__ + "create/static/media/background.574ba16e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateEvent/background.jpg
// module id = 418
// module chunks = 39